import { RootState } from 'app/store';
import { formsAdapter } from './forms.adapter';

export const { selectAll: selectForms } = formsAdapter.getSelectors(({ forms }: RootState) => forms.list);

export const formsListSelector = ({ forms }: RootState) => forms.list;

export const currentFormSelector = ({ forms }: RootState) => forms.current;

export const selectedFormSelector = ({ forms }: RootState) => forms.selected;
